module.exports = __webpack_public_path__ + "static/media/download_icon.ee9d83c0.svg";